import React, { useEffect, useState } from 'react';
import {
  CreateBase,
  SimpleForm,
  TextInput,
  SelectInput,
  useNotify,
  useRedirect,
  useCreate,
  required,
  useDataProvider,
} from "react-admin";
import Box from "@mui/material/Box";

interface Department {
  id: string;
  departmentName: string;
  description: string;
}

const PositionCreate: React.FC = () => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const redirect = useRedirect();
  const [create] = useCreate();
  const [departments, setDepartments] = useState<Department[]>([]);
  const [loading, setLoading] = useState(true);

  // ----------------------
  // 加载部门列表
  // ----------------------
  useEffect(() => {
    setLoading(true);

    dataProvider.getList('permissionDepartment', {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'id', order: 'ASC' },
      filter: {}
    })
      .then((res) => {
        setDepartments(res.data);
        setLoading(false);
      })
      .catch((e) => {
        console.error(e);
        notify('Error loading departments', { type: 'warning' });
        setLoading(false);
      });
  }, [dataProvider, notify]);

  if (loading) return <span>Loading...</span>;

  // ----------------------
  // 保存操作
  // ----------------------
  const handleSave = async (data: any) => {
    try {
      const payload = {
        positionName: data.positionName,
        departmentId: data.departmentId,
        description: data.description,
      };

      await create('permissionPosition', { data: payload });

      notify('Position created successfully', { type: 'success' });
      redirect('list', 'permissionPosition');
    } catch (error) {
      console.error('Create position error:', error);
      notify('Create failed', { type: 'error' });
    }
  };

  const departmentChoices = departments.map(dept => ({
    id: dept.id,
    name: dept.departmentName,
  }));

  return (
    <CreateBase resource="permissionPosition">
      <SimpleForm sx={{ backgroundColor: '#ffffff', padding: '36px' }} onSubmit={handleSave}>
        <Box display="flex" flexWrap="wrap" gap={2}>

          {/* 职级名称 */}
          <Box flex="1 1 48%">
            <TextInput
              source="positionName"
              label="Position Name"
              fullWidth
              validate={[required()]}
            />
          </Box>

          {/* 所属部门 */}
          <Box flex="1 1 48%">
            <SelectInput
              source="departmentId"
              label="Department"
              choices={departmentChoices}
              fullWidth
              validate={[required()]}
            />
          </Box>

          {/* 职级描述 */}
          <Box flex="1 1 100%">
            <TextInput
              source="description"
              label="Position Description"
              fullWidth
              multiline
              rows={3}
            />
          </Box>
        </Box>
      </SimpleForm>
    </CreateBase>
  );
};

export default PositionCreate;